import { render, staticRenderFns } from "./MobNavLanguageSwitch.vue?vue&type=template&id=f4a0b736&scoped=true"
import script from "./MobNavLanguageSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./MobNavLanguageSwitch.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobNavLanguageSwitch.vue?vue&type=style&index=0&id=f4a0b736&prod&lang=less"
import style1 from "./MobNavLanguageSwitch.vue?vue&type=style&index=1&id=f4a0b736&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a0b736",
  null
  
)

export default component.exports